"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var icons_1 = require("@material-ui/icons");
var classnames_1 = __importDefault(require("classnames"));
var React = __importStar(require("react"));
var useComponentStyles = core_1.makeStyles({
    commonContainer: {
        flex: '0 0 auto',
        '&:hover': {
            cursor: 'pointer',
        },
    },
    downloadLink: function (props) { return ({
        color: props.playerColors.active,
        textDecoration: 'none',
        '&:hover': {
            color: props.playerColors.hover,
        },
        '&:focus': {
            color: props.playerColors.active,
        },
        '&:active': {
            color: props.playerColors.active,
        },
    }); },
    downloadsContainer: {
        position: 'absolute',
        width: 'auto',
        top: '85%',
    },
    downloadsItemContainer: {
        padding: '8px 14px',
    },
    cloudDownloadIconContainer: {
        position: 'relative',
    },
    cloudDownloadIcon: function (props) { return ({
        color: props.playerColors.active,
        '&:hover': {
            color: props.playerColors.hover,
        },
    }); },
});
exports.AudioDownloadsControl = function (_a) {
    var src = _a.src, playerColors = _a.playerColors, _b = _a.classNames, classNames = _b === void 0 ? {} : _b;
    var classes = useComponentStyles({ playerColors: playerColors });
    var _c = React.useState(false), downloadsDropdownOpened = _c[0], openDownloadsDropdown = _c[1];
    var theme = core_1.useTheme();
    var toggleDownloadsDropdown = function (value) { return function () {
        openDownloadsDropdown(value);
    }; };
    var isMobile = core_1.useMediaQuery(theme.breakpoints.down('sm'));
    return Array.isArray(src) ? (isMobile ? (React.createElement(core_1.Grid, { item: true, className: classes.commonContainer },
        React.createElement("a", { className: classes.downloadLink, href: src[0], download: true },
            React.createElement(icons_1.CloudDownload, { fontSize: "large", className: classNames.downloadIcon })))) : (React.createElement(core_1.Grid, { item: true, className: classnames_1.default(classes.commonContainer, classes.cloudDownloadIconContainer), onMouseEnter: toggleDownloadsDropdown(true), onMouseLeave: toggleDownloadsDropdown(false) },
        React.createElement(icons_1.CloudDownload, { fontSize: "large", className: classnames_1.default(classes.cloudDownloadIcon, classNames.downloadsIcon) }),
        downloadsDropdownOpened && (React.createElement(core_1.Grid, { container: true, direction: "column", alignItems: "center", justify: "center", component: core_1.Paper, className: classes.downloadsContainer }, src.map(function (srcLink, index) {
            return (React.createElement(core_1.Grid, { key: index, item: true, className: classnames_1.default(classes.downloadsItemContainer, classNames.downloadsContainer) },
                React.createElement("a", { className: classnames_1.default(classes.downloadLink, classNames.downloadsItemLink), href: srcLink, download: true },
                    React.createElement(core_1.Typography, { color: "textPrimary", className: classNames.downloadsItemText }, srcLink
                        .substring(srcLink.lastIndexOf('.') + 1)
                        .toUpperCase()))));
        })))))) : (React.createElement(core_1.Grid, { item: true, className: classes.commonContainer },
        React.createElement("a", { className: classes.downloadLink, href: src, download: true },
            React.createElement(icons_1.CloudDownload, { fontSize: "large", className: classNames.downloadIcon }))));
};
exports.default = React.memo(exports.AudioDownloadsControl);
//# sourceMappingURL=AudioDownloadsControl.js.map